import { render, staticRenderFns } from "./TemplateCreate.vue?vue&type=template&id=3203fd5b&lang=pug"
import script from "./TemplateCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./TemplateCreate.vue?vue&type=style&index=0&id=3203fd5b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports